/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AuthenticationService } from './services/authentication.service';
import { DashboardReportService } from './services/dashboard-report.service';
import { FCCService } from './services/fcc.service';
import { FCCsMaintenanceService } from './services/fccs-maintenance.service';
import { LocationHistoryReportService } from './services/location-history-report.service';
import { LocationsMaintenanceService } from './services/locations-maintenance.service';
import { ManifestService } from './services/manifest.service';
import { OperationService } from './services/operation.service';
import { PatientService } from './services/patient.service';
import { PatientLookupMappingService } from './services/patient-lookup-mapping.service';
import { UserService } from './services/user.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AuthenticationService,
    DashboardReportService,
    FCCService,
    FCCsMaintenanceService,
    LocationHistoryReportService,
    LocationsMaintenanceService,
    ManifestService,
    OperationService,
    PatientService,
    PatientLookupMappingService,
    UserService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
